/**
 * @generated SignedSource<<76e0ae39eb15b7fa22294ebb33a30490>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreFlag = "Calendar" | "CustomerFeedback" | "EmployeeRole" | "GroupAccountsAndProfiles" | "MigratedTeamSchedule" | "OnbardedTeams" | "Product" | "ProductDateTracker" | "SignalWidget" | "TodoAsIssue" | "TodoNewTimlineAndComments" | "VersionSummer24";
export type StoreSuperAdminPanelFlagEditQuery$variables = Record<PropertyKey, never>;
export type StoreSuperAdminPanelFlagEditQuery$data = {
  readonly store: {
    readonly _adminAllStoreFlags: ReadonlyArray<StoreFlag>;
    readonly flags: ReadonlyArray<StoreFlag>;
    readonly id: string;
  };
};
export type StoreSuperAdminPanelFlagEditQuery = {
  response: StoreSuperAdminPanelFlagEditQuery$data;
  variables: StoreSuperAdminPanelFlagEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flags",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_adminAllStoreFlags",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreSuperAdminPanelFlagEditQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StoreSuperAdminPanelFlagEditQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "69dd3d4bfb5dd98c1f57fac547afc435",
    "id": null,
    "metadata": {},
    "name": "StoreSuperAdminPanelFlagEditQuery",
    "operationKind": "query",
    "text": "query StoreSuperAdminPanelFlagEditQuery {\n  store {\n    id\n    flags\n    _adminAllStoreFlags\n  }\n}\n"
  }
};
})();

(node as any).hash = "f968c4a0011c8df058e206896a9ca8ed";

export default node;
